import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { useIsPremiumEdition } from './index.tsx';

export const useIsTreeViewEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();
	const isAnonymous = useIsAnonymous();

	// For anonymous users on public views, we enable tree view since the backend won't expose non-premium views anyway
	return isPremium || isAnonymous;
};
